import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

export const base: CSSProperties | any = {
  // FIXME: WebkitFontSmoothing
  fontFamily,
  fontSize: 14,
  color: greys.slate,
  width: "100%",
  justifyContent: "start",
  textAlign: "left",
  WebkitFontSmoothing: "antialiased",
  boxShadow: "none",
};

export const label: CSSProperties = {
  fontFamily,
  display: "inline-block",
  marginBottom: -3,
  padding: "0 8px",
};

export const icon = {
  height: 20,
  width: 20,
  marginLeft: 5,
  marginRight: 5,
};
